// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"298":"eb5f351b","881":"f64d8b3d"}[chunkId] + ".chunk.css";
};